import { call, put, select } from 'redux-saga/effects';
import * as actions from './actions';
import { produce } from 'immer';
import axios from 'axios';
import { sagas as eventSagas } from 'store/event';
import { updateBatchFilters } from './actions';
import {
  convertToDateTimeFormat2OnlyString,
  timeTaken
} from 'helpers/timeUtils';

const { waitForGetSupportedEventTypes } = eventSagas;

const getTransformedBatch = batch => {
  batch.timeTaken = batch.endTime
    ? timeTaken(batch.createTime, batch.endTime)
    : '-';
  batch.createTime = convertToDateTimeFormat2OnlyString(batch.createTime);
  batch.status = batch.status.toUpperCase();
  batch.type = batch.isHtml ? 'HTML' : 'PDF';

  return batch;
};

// the actual http calls
const apiRoot = `${window._env_?.REACT_APP_PRINT_API_PATH}`;

const getBatchesApiRoot = (tenantId, businessContextId) =>
  `${apiRoot}tenants/${tenantId}/context/${businessContextId}`;

export const getPaginatedTemplatesAsync = (
  tenantId,
  businessContextId,
  urlParams,
  bodyParams
) => {
  return axios
    .post(
      `${getBatchesApiRoot(tenantId, businessContextId)}/batch/search?index=${
        urlParams.index
      }&pageSize=${urlParams.pageSize}`,
      bodyParams
    )
    .then(response => ({
      data: response.data,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });
};

// selectors
const currentTenantId = store => store.user.selectedTenant.tenantId;
const currentBusinessContextId = store =>
  store.user.selectedBusinessContext.businessContextId;
const paginatedTemplateList = store =>
  store.template ? store.batches.paginatedList : [];
const searchInput = store =>
  store.batches.filters ? store.batches.filters?.searchInput : '';
const sortBy = store =>
  store.batches.filters ? store.batches.filters?.sortBy : 'name';
const sortOrder = store =>
  store.batches.filters ? store.batches.filters?.sortOrder : 'ASC';
const rowsPerPage = store =>
  store.batches.filters ? store.batches.filters?.rowsPerPage : 10;
const pageNo = store =>
  store.batches.filters ? store.batches.filters?.pageNo : 0;
const filterTypes = store =>
  store.batches.filters ? store.batches.filters?.filterTypes : [];

const getParams = requestParams => {
  for (let param in requestParams) {
    if (param == 'name' && requestParams[param].length == 0) {
      delete requestParams[param];
    }
    if (param === 'sortBy' && requestParams[param] === 'name') {
      requestParams[param] = 'createTime';
      requestParams['sortOrder'] = 'DESC';
    }
    if (param === 'isHtml' && requestParams[param]?.length === 0 || requestParams[param]?.length === 2) {
      delete requestParams[param];
    } else if (param === 'isHtml' && requestParams[param]?.length === 1) {
      requestParams[param] = requestParams[param][0] === 'HTML' ? true : false;
    }
  }
  return requestParams;
};
export function* getPaginatedBatchesIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let currentList = yield select(paginatedTemplateList);
    yield call(waitForGetSupportedEventTypes);

    if (
      action.type === actions.GET_PAGINATED_BATCHES &&
      (currentList.length === 0 || payload.force === true)
    ) {
      const requestBody = {
        name: yield select(searchInput),
        sortBy: yield select(sortBy),
        sortOrder: yield select(sortOrder),
        isHtml: yield select(filterTypes)
      };
      let urlParams = {
        index: yield select(pageNo),
        pageSize: yield select(rowsPerPage)
      };
      let bodyParams = { ...getParams(requestBody) };
      yield put(actions.gettingPaginatedBatches());
      currentList = yield call(
        getPaginatedTemplatesAsync,
        tenantId,
        businessContextId,
        urlParams,
        bodyParams
      );
      currentList.data = produce(currentList.data, batches => {
        batches = batches.map(getTransformedBatch);
      });
      yield put(updateBatchFilters({ totalCount: currentList.totalRecords }));
    }
    yield put(actions.gettingPaginatedBatchesSucceeded(currentList.data));
  } catch (ex) {
    yield put(updateBatchFilters({ totalCount: 0 }));
    yield put(actions.gettingPaginatedBatchesFailed(ex));
  }
}

export function* downloadAttachmentFile(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    window.open(
      `${getBatchesApiRoot(tenantId, businessContextId)}/download/${
        payload.attachmentId
      }?download=${payload.isDownload}`,
      '_blank'
    );
  } catch (ex) {
    yield put(actions.gettingPaginatedBatchesFailed(ex));
  }
}
